import { useQuery } from '@tanstack/react-query';
import * as actions from './actions';

export function useMedications(params: actions.GetMedicationParams) {
    return useQuery(['get-medications'], () => actions.getMedications(params));
}
